const MIN_VISUAL_ZOOM = 13;
const MAX_VISUAL_ZOOM = 16;

export const getZoomProgress = (
  zoom,
  minZoom = MIN_VISUAL_ZOOM,
  maxZoom = MAX_VISUAL_ZOOM
) => {
  const numericZoom = Number(zoom);
  const safeMin = Number(minZoom);
  const safeMax = Number(maxZoom);
  const range = safeMax - safeMin;

  if (!Number.isFinite(range) || range <= 0) return 1;

  const resolvedZoom = Number.isFinite(numericZoom) ? numericZoom : safeMax;
  const clampedZoom = Math.min(safeMax, Math.max(safeMin, resolvedZoom));
  return (clampedZoom - safeMin) / range;
};

export const getTrafficDotProfile = (zoom) => {
  const zoomProgress = getZoomProgress(zoom);

  return {
    scale: 3 + (4.5 * zoomProgress),
    spawnIntervalMs: 5000 - (3000 * zoomProgress)
  };
};

export const getHouseMarkerSize = (zoom) => {
  const zoomProgress = getZoomProgress(zoom);
  return 20 + (30 * zoomProgress);
};
